import React from "react";
import { Instagram, Facebook, ArrowUpRight, Building2, Phone, MapPin } from "lucide-react";

export default function Footer({ content }) {
  const brand = content?.brand || {};
  const footer = content?.footer || {};
  const header = content?.header || {};
  const year = new Date().getFullYear();

  return (
    <footer data-testid="site-footer" className="bg-black text-stone-300 pt-14 pb-8">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-10 pb-16 border-b border-stone-800">
          <div>
            <p className="text-xs tracking-[0.3em] uppercase text-amber-500 font-semibold mb-6">
              {brand.tagline}
            </p>
            <h2 className="font-serif text-6xl sm:text-7xl lg:text-8xl tracking-tighter text-stone-50 leading-none">
              {brand.name || "Aurora"}
            </h2>
          </div>
          <div className="flex flex-wrap gap-3">
            <a
              href={header.orderButton?.url || "#"}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-order-btn"
              className="inline-flex items-center gap-2 rounded-full border border-stone-700 px-6 py-3 text-sm font-medium text-stone-100 hover:bg-stone-800 transition-colors duration-300"
            >
              {header.orderButton?.label || "Peça e Retire"} <ArrowUpRight className="h-4 w-4" />
            </a>
            <a
              href={header.deliveryButton?.url || "#"}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-delivery-btn"
              className="inline-flex items-center gap-2 rounded-full bg-amber-700 px-6 py-3 text-sm font-medium text-stone-50 hover:bg-amber-600 transition-colors duration-300"
            >
              {header.deliveryButton?.label || "Delivery"} <ArrowUpRight className="h-4 w-4" />
            </a>
          </div>
        </div>

        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6 pt-8">
          <p className="text-sm text-stone-500 max-w-sm">{footer.note}</p>
          <div className="flex items-center gap-4">
            {footer.instagram && (
              <a href={footer.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram"
                className="grid place-items-center h-10 w-10 rounded-full border border-stone-800 hover:border-amber-500 hover:text-amber-500 transition-colors duration-300">
                <Instagram className="h-4 w-4" />
              </a>
            )}
            {footer.facebook && (
              <a href={footer.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook"
                className="grid place-items-center h-10 w-10 rounded-full border border-stone-800 hover:border-amber-500 hover:text-amber-500 transition-colors duration-300">
                <Facebook className="h-4 w-4" />
              </a>
            )}
          </div>
        </div>

        {/* Institutional info */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 pt-8 border-t border-stone-800/60">
          <div data-testid="footer-cnpj" className="flex items-start gap-3">
            <Building2 className="h-4 w-4 text-amber-500 mt-1 shrink-0" />
            <div>
              <p className="text-[10px] tracking-[0.2em] uppercase text-stone-500 font-semibold">CNPJ</p>
              <p className="text-sm text-stone-300 mt-1">{footer.cnpj}</p>
            </div>
          </div>
          <div data-testid="footer-sac" className="flex items-start gap-3">
            <Phone className="h-4 w-4 text-amber-500 mt-1 shrink-0" />
            <div>
              <p className="text-[10px] tracking-[0.2em] uppercase text-stone-500 font-semibold">SAC</p>
              <p className="text-sm text-stone-300 mt-1">{footer.sac}</p>
            </div>
          </div>
          <div data-testid="footer-address" className="flex items-start gap-3">
            <MapPin className="h-4 w-4 text-amber-500 mt-1 shrink-0" />
            <div>
              <p className="text-[10px] tracking-[0.2em] uppercase text-stone-500 font-semibold">Endereço</p>
              <p className="text-sm text-stone-300 mt-1">{footer.address}</p>
            </div>
          </div>
        </div>

        <div className="mt-8 text-xs text-stone-600">
          <span>© {year} {brand.name}. Todos os direitos reservados.</span>
        </div>
      </div>
    </footer>
  );
}

